import ApiService from "../../../../services/ApiService";
import translate from "../../../../services/Translate";
import { FormType } from "./AddDemoRecordPopup.d";

export const updateFormField = (
  e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  setForm: React.Dispatch<React.SetStateAction<FormType>>
) => {
  const { name, value } = e.target;
  setForm((prev) => ({ ...prev, [name]: value }));
};

export const submitDemoRecord = (form: FormType, language: string, setLoading: Function, onSuccess: Function) => {
  if (!form.name || !form.author_id) {
    alert(translate(language, "PAGES.DEV.ADD_RECORD.ERROR.REQUIRED_FIELDS"));
    return;
  }

  setLoading(true);
  ApiService.post("demos/records", form)
    .then(() => {
      onSuccess();
    })
    .catch((error) => {
      if (error?.data?.error?.message?.includes("already exists")) {
        alert(translate(language, "PAGES.DEV.ADD_RECORD.ERROR.ALREADY_EXISTS"));
      } else {
        alert(translate(language, "PAGES.DEV.ADD_RECORD.ERROR.DEFAULT_TEXT"));
      }
    })
    .finally(() => setLoading(false));
};
